import { Button, Dialog } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import React, { FC } from "react";
import { useIntl } from "react-intl";

import useStyle from "./styles";

export interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
}

const ConfirmModal: FC<ConfirmModalProps> = ({ open, onClose }) => {
  const intl = useIntl();
  const classes = useStyle();

  return (
    <Dialog
      style={{ borderRadius: 16 }}
      className={classes.root}
      open={open}
      onClose={onClose}
    >
      <MyTypography variant="subtitle1" className={classes.title}>
        {intl.formatMessage({
          defaultMessage: "ระบบ eOrdering\n ได้รับข้อมูลของคุณเรียบร้อยแล้ว"
        })}
      </MyTypography>
      <Button onClick={onClose} variant="contained" color="secondary">
        {intl.formatMessage({ defaultMessage: " ปิดหน้าต่าง" })}
      </Button>
    </Dialog>
  );
};

export default ConfirmModal;
